var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import clsx from "clsx";
import React from "react";
import DefaultLink from "./Link";
import * as defaultStyles from "./Breadcrumbs.module.css";
import withComponentDefaults from "../utils/withComponentDefaults";
import { filterAttributes } from "../utils";
export default withComponentDefaults(Breadcrumbs, "breadcrumbs");
function Breadcrumbs(_a) {
  var _b = _a,
    {
      label = "Br\xF6dsmulor",
      description = "Du \xE4r h\xE4r:",
      hideDescription = false,
      components: {
        Link = DefaultLink
      } = {
        Link: DefaultLink
      },
      items,
      separator = "/",
      styles = defaultStyles,
      className
    } = _b,
    restProps = __objRest(_b, ["label", "description", "hideDescription", "components", "items", "separator", "styles", "className"]);
  let attributes = filterAttributes(restProps);
  return /* @__PURE__ */React.createElement("nav", __spreadValues({
    "aria-label": label,
    className: clsx(styles.component, className)
  }, attributes), /* @__PURE__ */React.createElement("p", {
    className: clsx(styles.description, hideDescription && styles.sronly)
  }, description), /* @__PURE__ */React.createElement("ol", {
    className: clsx(styles.list)
  }, items.map((item, index) => {
    return /* @__PURE__ */React.createElement("li", {
      key: index,
      className: clsx(styles.item)
    }, index !== 0 && /* @__PURE__ */React.createElement("span", {
      className: styles.separator,
      "aria-hidden": "true"
    }, separator), /* @__PURE__ */React.createElement(Link, {
      to: item.url,
      className: clsx(styles.link),
      "aria-current": index === items.length - 1 ? "page" : null
    }, item.label));
  })));
}